export const GET_HAIR_PRESCRRIPTION_AMEND_ANSWER = "GET_HAIR_PRESCRRIPTION_AMEND_ANSWER"
export const SET_HAIR_PRESCRRIPTION_AMEND_ANSWER_ERROR_PAGE = "SET_HAIR_PRESCRRIPTION_AMEND_ANSWER_ERROR_PAGE";